import { createContext } from 'react';

export type ToastTone = 'success' | 'error' | 'info';

export type ToastContextValue = {
  /** Shows a toast; it dismisses itself after a few seconds. */
  notify: (message: string, tone?: ToastTone) => void;
};

export const ToastContext = createContext<ToastContextValue | undefined>(undefined);
